import{palette as r}from"../../../theme/units/palette.js";var t=function(){return r().background.paper};export{t as getVisualizationBackgroundColor};
